import { ExportColumn } from '../../../interfaces/ExportColumn';

const userTypeColumns = [
  {
    title: 'User Level',
    dataIndex: 'userLevel',
    key: 'userLevel',
    width: '150px',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: '250px',
  },
  {
    title: 'Access Rights',
    dataIndex: 'accessRights',
    key: 'accessRights',
    width: '200px',
  },
];

const generalPermissionsColumns = [
  {
    title: 'Permission',
    dataIndex: 'permission',
    key: 'permission',
    width: '150px',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: '300px',
  },
];

// export excel

const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    width: 35,
  },
  {
    key: 'roles.selectedValue',
    header: 'User Type',
    type: 'text',
    width: 35,
    placeholder: 'Not Assigned',
  },
];

export { userTypeColumns, generalPermissionsColumns, baseColumns };
